import { render, staticRenderFns } from "./SlideInPanel.vue?vue&type=template&id=3a2e5492&scoped=true&lang=pug&functional=true&"
var script = {}
import style0 from "./SlideInPanel.vue?vue&type=style&index=0&id=3a2e5492&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3a2e5492",
  null
  
)

export default component.exports